/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable react/jsx-no-target-blank */
import { useIntl } from 'react-intl'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { AsideMenuItem } from './AsideMenuItem'
import { useEffect, useState } from 'react'
import { GET } from '../../../../app/services/api'
import { i18n } from '../../../../app/translate/i18n'
import useAuth from '../../../../app/hooks/useAuth'
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import usePluginsSpace from '../../../../app/hooks/usePluginSpace'

const menuStyles = `
  .menu-item.here.show > .menu-sub {
    display: block;
  }
  
  .menu-item .menu-sub.show {
    display: block;
  }
  
  .menu-item .menu-link.active {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff;
  }
  
  .menu-item.here.show > .menu-link {
    background-color: rgba(255, 255, 255, 0.05);
  }
`

export type MenuType = {
  icon: string
  id: number
  name: string
  newIcon: string
  order: number
  parent: number
  route: string
  submenu: SubMenuType[]
  type: string
  permissionParent?: boolean
}

type SubMenuType = {
  id: number
  name: string
  newIcon: string
  order: number
  parent: number
  router: string
  externalLink?: boolean
}

// Helper function to ensure correct translation
const getMenuTranslation = (itemName: string): string => {
  // Hard-coded translations for problematic items
  const hardcodedTranslations: { [key: string]: string } = {
    'ct_data_cost_account': 'Dados e Custos',
    'ct_account': 'Consumo e Valor',
    'ct_s3_account': 'Conta S3',
    'consumption': 'Consumo IA',
    'summarize': 'Dashboard',
    'cost': 'Custos'
  }

  // First try hardcoded translation
  if (hardcodedTranslations[itemName]) {
    return hardcodedTranslations[itemName]
  }

  // Then try i18n translation
  const translation = i18n.t(`permissions.${itemName}`)

  // If i18n returns the key itself (meaning no translation found), return the hardcoded or original name
  if (translation === `permissions.${itemName}`) {
    return hardcodedTranslations[itemName] || itemName
  }

  return translation
}

export function AsideMenuMain() {
  const intl = useIntl()

  const [menu, setMenu] = useState<MenuType[]>([])
  const [menuOriginal, setMenuOriginal] = useState<MenuType[]>([])
  const { loginInfo, verifyAdm, verifyCommonAdmin, verifyPluginSpace } = useAuth()
  const { integrations } = usePluginsSpace()
  const navigate = useNavigate()

  useEffect(() => {
    const styleElement = document.createElement('style')
    styleElement.innerHTML = menuStyles
    document.head.appendChild(styleElement)

    return () => {
      document.head.removeChild(styleElement)
    }
  }, [])

  function verifyPermission() {
    if (menu && menu.length > 0) {
      let permission = false

      menu.forEach((order: MenuType) => {
        if (order.submenu && order.submenu.length > 0) {
          order.submenu.forEach((submenu) => {
            const route = submenu.router.split('./')[1]
              ? submenu.router.split('./')[1]
              : submenu.router.split('./')[0]
            if (route && window.location.pathname.includes(route) && order.permissionParent) {
              permission = true
            }
          })
        } else {
          const route = order.route.split('./')[1]
            ? order.route.split('./')[1]
            : order.route.split('./')[0]
          if (route && window.location.pathname.includes(route) && order.permissionParent) {
            permission = true
          }
        }
      })
      if (
        !permission &&
        !window.location.pathname.includes('dashboard') &&
        !window.location.pathname.includes('pluginspace') &&
        !window.location.pathname.includes('icon') &&
        !window.location.pathname.includes('error') &&
        !window.location.pathname.includes('auth') &&
        !window.location.pathname.includes('copy-configurations')
      ) {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Você não tem permissão de acessar essa página!',
        })
        navigate('/dashboard')
      }
    }
  }

  async function fetchMenu() {
    try {
      const response = await GET('/pages/buildMenuPage')
      if (response) {
        let menuOrder: MenuType[] = response.sort((a: MenuType, b: MenuType) => a.order - b.order)
        //

        menuOrder.map((item) => {

          if (item.name === 'support' && verifyPluginSpace()) {
            item.submenu.push({
              id: 10000,
              name: "translate",
              parent: 1144,
              router: "./pluginspace_translate",
              newIcon: '',
              order: 2,
            })
          }

          return item
        })

        setMenuOriginal(menuOrder)
        setMenu(menuOrder)

        // Force i18n reload to ensure translations are fresh
        await i18n.reloadResources()
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    fetchMenu()
  }, [])
  useEffect(() => {
    verifyPermission()
  }, [window.location.pathname])
  useEffect(() => {
    verifyPermission()
  }, [menu])

  function updateMenuSDS() {
    if (loginInfo.plugintype === 'hospitality') {
      menuSdsHospitality()
    } else {
      menuSdsFood()
    }
  }

  function menuSdsFood() {
    const hasSDS = menuOriginal.findIndex((menu) => menu.name === 'SDS')
    const sdsConfig: any = integrations.find((integration) => integration.plugintemplateId === 101)
    let newMenu = menuOriginal.map((el) => el)
    if (hasSDS !== -1 && sdsConfig) {
      const loginData = btoa(
        JSON.stringify({ email: sdsConfig.content.email, pdw: sdsConfig.content.pwd })
      )

      let url = ''
      switch (process.env.REACT_APP_PROD) {
        case '3':
          url = `https://sds-admin-dev.ninegrid.com.br/auth/login?loginInfo=${loginData}`
          break
        case '0':
          url = `https://sds-admin-staging.ninegrid.com.br/auth/login?loginInfo=${loginData}`
          break
        case '1':
          url = `https://sds-admin.ninegrid.com.br/auth/login?loginInfo=${loginData}`
          break
      }
      if (!newMenu[hasSDS].submenu.find((x) => x.name === 'sds_link')) {
        newMenu[hasSDS].submenu.push({
          id: 1159,
          name: 'sds_link',
          parent: 1158,
          router: url,
          newIcon:
            '<!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2021-03-11-144509/theme/html/demo1/dist/../src/media/svg/icons/Devices/Tablet.svg--><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><rect x="0" y="0" width="24" height="24"/><path d="M6.5,4 L6.5,20 L17.5,20 L17.5,4 L6.5,4 Z M7,2 L17,2 C18.1045695,2 19,2.8954305 19,4 L19,20 C19,21.1045695 18.1045695,22 17,22 L7,22 C5.8954305,22 5,21.1045695 5,20 L5,4 C5,2.8954305 5.8954305,2 7,2 Z" fill="#000000" fill-rule="nonzero"/><polygon fill="#000000" opacity="0.3" points="6.5 4 6.5 20 17.5 20 17.5 4"/></g></svg><!--end::Svg Icon-->',
          order: 99,
          externalLink: true,
        })
      }

      setMenu(newMenu)
    } else if (hasSDS !== -1 && !sdsConfig) {
      setMenu(newMenu.filter((m) => m.name !== 'SDS'))
    }
  }

  function menuSdsHospitality() {
    const sdsConfigHospitalitys = integrations.filter(
      (integration) => integration.plugintemplateId === 101
    )
    const hasSDS = menuOriginal.findIndex((menu) => menu.name === 'SDS')
    const sdsConfigRestaurant: any = sdsConfigHospitalitys.find(
      (integration: any) => integration.content.type === '1'
    )
    const sdsConfigService: any = sdsConfigHospitalitys.find(
      (integration: any) => integration.content.type === '2'
    )

    let newMenu = menuOriginal.map((el) => el)

    if (hasSDS !== -1 && sdsConfigRestaurant) {
      const loginData = btoa(
        JSON.stringify({
          email: sdsConfigRestaurant.content.email,
          pdw: sdsConfigRestaurant.content.pwd,
        })
      )

      let url = ''
      switch (process.env.REACT_APP_PROD) {
        case '3':
          url = `https://sds-admin-dev.ninegrid.com.br/auth/login?loginInfo=${loginData}`
          break
        case '0':
          url = `https://sds-admin-staging.ninegrid.com.br/auth/login?loginInfo=${loginData}`
          break
        case '1':
          url = `https://sds-admin.ninegrid.com.br/auth/login?loginInfo=${loginData}`
          break
      }

      if (!newMenu[hasSDS].submenu.find((x) => x.name === 'sds_link')) {
        newMenu[hasSDS].submenu.push({
          id: 1159,
          name: 'sds_link',
          parent: 1158,
          router: url,
          newIcon:
            '<!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2021-03-11-144509/theme/html/demo1/dist/../src/media/svg/icons/Devices/Tablet.svg--><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><rect x="0" y="0" width="24" height="24"/><path d="M6.5,4 L6.5,20 L17.5,20 L17.5,4 L6.5,4 Z M7,2 L17,2 C18.1045695,2 19,2.8954305 19,4 L19,20 C19,21.1045695 18.1045695,22 17,22 L7,22 C5.8954305,22 5,21.1045695 5,20 L5,4 C5,2.8954305 5.8954305,2 7,2 Z" fill="#000000" fill-rule="nonzero"/><polygon fill="#000000" opacity="0.3" points="6.5 4 6.5 20 17.5 20 17.5 4"/></g></svg><!--end::Svg Icon-->',
          order: 99,
          externalLink: true,
        })
      }
    } else if (hasSDS !== -1 && !sdsConfigRestaurant) {
      newMenu = newMenu.filter((m) => m.name !== 'SDS')
    }

    if (sdsConfigService) {
      const hasServiceMenu = menu.findIndex((menu) => menu.name === 'service')

      if (hasServiceMenu !== -1) {
        newMenu[hasServiceMenu].submenu.push({
          id: 1159,
          name: 'sds_display',
          parent: newMenu[hasServiceMenu].id,
          router: '/sds/manage-hospitality',
          newIcon:
            '<!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2021-03-11-144509/theme/html/demo1/dist/../src/media/svg/icons/Devices/Tablet.svg--><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><rect x="0" y="0" width="24" height="24"/><path d="M6.5,4 L6.5,20 L17.5,20 L17.5,4 L6.5,4 Z M7,2 L17,2 C18.1045695,2 19,2.8954305 19,4 L19,20 C19,21.1045695 18.1045695,22 17,22 L7,22 C5.8954305,22 5,21.1045695 5,20 L5,4 C5,2.8954305 5.8954305,2 7,2 Z" fill="#000000" fill-rule="nonzero"/><polygon fill="#000000" opacity="0.3" points="6.5 4 6.5 20 17.5 20 17.5 4"/></g></svg><!--end::Svg Icon-->',
          order: 99,
        })
      }
    }

    setMenu(newMenu)
  }

  useEffect(() => {
    updateMenuSDS()
  }, [integrations.length, menu.length])

  return (
    <>
      {loginInfo.plugintype !== 'aggregator' && (
        <AsideMenuItem
          to='/dashboard'
          icon='/media/icons/duotune/general/gen001.svg'
          title={intl.formatMessage({ id: 'MENU.DASHBOARD' })}
          fontIcon='bi-app-indicator'
        />
      )}
      {menu.sort((a, b) => (a.order > b.order ? 1 : b.order > a.order ? -1 : 0)).map((item, i) => {
        if (item.submenu.length > 0 && item.route.includes('javascript')) {
          return (
            <AsideMenuItemWithSub
              key={`menu-${i}`}
              to=''
              title={getMenuTranslation(item.name)}
              icon={
                item.newIcon ? item.newIcon.replaceAll('fill="#000000"', 'fill="currentColor"') : ''
              }
            >
              {item.submenu
                .sort((a, b) => (a.order > b.order ? 1 : b.order > a.order ? -1 : 0))
                .map((subItem, j) => {
                  if (subItem.name === 'charge_integration' || subItem.name === 'cost') {
                    if (verifyAdm() === true || verifyCommonAdmin() === true) {
                      return (
                        <AsideMenuItem
                          key={`subitem-${j}`}
                          to={subItem.router ? subItem.router.replaceAll('./', '/') : ''}
                          title={getMenuTranslation(subItem.name)}
                          hasBullet={true}
                        />
                      )
                    } else {
                      return
                    }
                  } else {
                    return (
                      <AsideMenuItem
                        key={`subitem-${j}`}
                        to={subItem.router ? subItem.router.replaceAll('./', '/') : ''}
                        title={getMenuTranslation(subItem.name)}
                        hasBullet={true}
                        externalLink={subItem.externalLink}
                      />
                    )
                  }
                })}
            </AsideMenuItemWithSub>
          )
        } else {
          if (item.permissionParent) {
            return (
              <AsideMenuItem
                key={`item-${i}`}
                to={item.route ? item.route.replaceAll('./', '/') : ''}
                title={getMenuTranslation(item.name)}
                hasBullet={false}
                icon={
                  item.newIcon
                    ? item.newIcon.replaceAll('fill="#000000"', 'fill="currentColor"')
                    : ''
                }
              />
            )
          }
        }
      })}
    </>
  )
}
